import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { LegislationService } from 'app/_services/legislation.service';
import { NotificationService } from 'app/_services/notification.service';
import { LegislationItem, LGI_COLUMNS, LGI_SELECTED_COLUMNS } from './legislation';

@Component({
    selector: 'app-legislation-items',
    templateUrl: './legislation-items.component.html',
    styleUrls: ['../../shared/table-defaults.scss', '../legislation.component.scss', './legislation-items.component.scss'],
})
export class LegislationItemsComponent implements OnInit {
    isLoading = true;
    legislationItems: LegislationItem[];
    dataSource: MatTableDataSource<LegislationItem>;

    selectedColumns = LGI_SELECTED_COLUMNS;
    schoolColumns = LGI_COLUMNS;
    columnsToDisplay = [ ...LGI_SELECTED_COLUMNS, 'actions'];
    stickyColumns = [LGI_COLUMNS[0], 'actions'];

    @Output() editLegislationItem = new EventEmitter<LegislationItem>();
    @Output() viewLegislationItem = new EventEmitter<LegislationItem>();
    
    @ViewChild(MatTable) table: MatTable<LegislationItem>;

    constructor(
        private dialogService: DialogsService,
        private legislationService: LegislationService,
        private notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        const self = this;
        self.legislationService.getLegislationItems().subscribe( items => {
            self.legislationItems = items;
            self.loadDatasource(self.legislationItems);
            self.isLoading = false;
        });
    }

    typeOf(field: any): any {
        return typeof field;
    }

    trackBy(_index: number, legislationItem: LegislationItem) {
        return legislationItem.legislationItemId;
    }

    loadDatasource(data: LegislationItem[]): void {
        this.dataSource = null;
        this.dataSource = new MatTableDataSource(data);
    }

    loadData() {
        const self = this;

        self.legislationService.getLegislationItems().subscribe( items => {
            self.legislationItems = items;
            self.loadDatasource(self.legislationItems);
        })
    }

    applyFilter(searchTerms: any): void {
        this.dataSource.filter = searchTerms;

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    clearFilter(): void {
        this.dataSource.filter = '';

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    editItem(legislationItem: LegislationItem): void {
        this.editLegislationItem.emit(legislationItem);
    }

    deleteItem(legislationItem: LegislationItem): void {
        const self = this;
        const dialogResult$ = self.dialogService.OpenConfirmationDialog({
            TitleText: 'Delete Legislation Item',
            MessageText: 'Are you sure you want to delete this legislation item?',
            OKText: 'Yes, remove item',
            CancelText: 'No',
        });

        dialogResult$.subscribe((result) => {
            if (!result) {
                return;
            }

            const index = self.dataSource.data.indexOf(legislationItem, 0);

            if (index > -1) {
                self.dataSource.data.splice(index, 1);
            }

            self.legislationService.deleteLegislationItem(legislationItem.legislationItemId).subscribe();
            self.table.renderRows();
            self.notificationService.showSuccess(`Legislation item have been removed.`);
        });
    }
}
